import { render, staticRenderFns } from "./GCustomCompetencySelection.vue?vue&type=template&id=85dbf55a&"
import script from "./GCustomCompetencySelection.vue?vue&type=script&lang=ts&"
export * from "./GCustomCompetencySelection.vue?vue&type=script&lang=ts&"
import style0 from "./GCustomCompetencySelection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports